
import { dataKey, State, Widget, widgetType } from '@/types';
import { defineComponent, inject, PropType, reactive, ref } from 'vue';
export default defineComponent({
	props: {
		me: {
			type: Object as PropType<Widget>,
			required: true,
		},
	},
	setup(props) {
		const me = reactive(props.me);
		const isShow = ref(false);
		const state: State = inject<any>(dataKey.STATE);

		// 处理选中
		const selectCurWidget = (e: MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();
			state.curWidget = me;
		};

		return { widgetType, isShow, selectCurWidget };
	},
});
